import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import { Grid, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";

import instance from "../../axios";
import pieChartDefault from "../../Components/common/Charts/pieChartDefault";
import Select from "react-select";
import moment from "moment";
import Button from "../../Components/common/Button";
import Tooltip from "@mui/material/Tooltip";
import { nFormatter, replaceSpecialCh } from "../../Helpers";
import Skeleton from "@mui/material/Skeleton";
import axios from 'axios'
import { addTab10, addTab11, addTab13, addTab14, addTab1, addTab2, addTab3, addTab4, addTab5, addTab6, addTab7, addTab8, addTab9, addTab15, addTab18, addTab17, addTab19 } from "../../Actions/MaintDashboard";
// import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.css';

// import { ConsoleWriter } from "istanbul-lib-report";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highmaps";
import { Scrollbar } from "react-scrollbars-custom";
import withRoutes from "../../HOC/HocRoutes";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { FiltersOption, FiltersOptionWithoutMTD, MaintenanceItemEmpty } from "../MaintenanceDashboard/MaintenanceDashboard";

const MoreWidgets = (props) => {
    const [state, setState] = useState({
        loader1: false,
        tab1: "",
        tab2: "",
        // ... all tabs
    });
    const logInUser = useSelector((state) => state.logInUsers)
    const tab1 = useSelector((state) => state.tab1)
    const tab2 = useSelector((state) => state.tab2)
    const tab13 = useSelector((state) => state.tab13)
    const tab6 = useSelector((state) => state.tab6)
    const tab8 = useSelector((state) => state.tab8)
    const tab4 = useSelector((state) => state.tab4)
    const tab5 = useSelector((state) => state.tab5)
    const tab7 = useSelector((state) => state.tab7)
    const tab9 = useSelector((state) => state.tab9)
    const tab10 = useSelector((state) => state.tab10)
    const tab11 = useSelector((state) => state.tab11)
    const tab3 = useSelector((state) => state.tab3)
    const tab17 = useSelector((state) => state.tab17)
    const tab19 = useSelector((state) => state.tab19)
    const tab14 = useSelector((state) => state.tab14)
    const tab18 = useSelector((state) => state.tab18)
    const dispatch = useDispatch()
    const getToFrom = (value) => {
        let timezone = "";
        if (
            props.logInUser &&
            props.logInUser.attributes &&
            props.logInUser.attributes.timezone
        ) {
            timezone = props.logInUser.attributes.timezone
        } else {
            timezone = "Asia/Riyadh"
        }

        const now = moment().tz(timezone);

        if (value === 1) {
            const startOfMonth = now.clone().startOf("month");
            const endOfMonth = now.clone().endOf("month");

            return {
                from: startOfMonth.toISOString(),
                to: endOfMonth.toISOString(),
            };
        } else if (value === 2) {
            const lastMonthStart = now.clone().subtract(1, "month").startOf("month");
            const lastMonthEnd = now.clone().subtract(1, "month").endOf("month");

            return {
                from: lastMonthStart.toISOString(),
                to: lastMonthEnd.toISOString(),
            };
        } else if (value === 3) {
            const threeMonthsAgo = now.clone().subtract(3, "months");
            const startOfThreeMonthsAgo = threeMonthsAgo.clone().startOf("month");
            const endOfLastMonth = now.clone().subtract(1, "month").endOf("month");

            return {
                from: startOfThreeMonthsAgo.toISOString(),
                to: endOfLastMonth.toISOString(),
            };
        } else if (value === 4) {
            const startOfYear = now.clone().startOf("year");

            return {
                from: startOfYear.toISOString(),
                to: now.toISOString(),
            };
        } else if (value === 6) {
            return {
                from: false,
                to: false,
            };
        } else {
            const lastYearStart = now.clone().subtract(1, "year").startOf("year");
            const lastYearEnd = now.clone().subtract(1, "year").endOf("year");

            return {
                from: lastYearStart.toISOString(),
                to: lastYearEnd.toISOString(),
            };
        }
    };
    const getCMS4 = (to, from, tab1) => {
        setState((prevState) => ({
            ...prevState,
            loader4: tab1 ? false : true, tab1loader5: tab1 ? true : false
        }))
        let url =
            to && from
                ? `/api/dashboards/cms/4?to=${to}&from=${from}`
                : `/api/dashboards/cms/4`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let maxUsedCount = Math.max(
                    ...res.clientList.map((item) => item.saleNetAmount)
                );
                let usedPartPercentages = res.clientList.map((item) => {
                    return {
                        ...item,
                        salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
                    };
                });

                if (tab1) {
                    setState((prevState) => ({
                        ...prevState,
                        loader4: false,
                        tab1loader5: false,
                        salesClientsTab1: res.totalSaleTotalAmount,
                        salesClients1: {
                            ...res,
                            clientList: usedPartPercentages,
                        }
                    }))

                } else {
                    setState((prevState) => ({
                        ...prevState,
                        tab1loader5: false,

                        salesClients: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        loader4: false,
                    }))
                }
                let dat = {
                    res: res,
                    initFetch: true,

                }
                // props.dispatch(addTab5(dat)); 

            })
            .catch((err) => { });

    };
    const getDashboardData = (from, to, startOfMonth, endOfMonth, lastYearStart, lastYearEnd) => {
        let tab1Data = {}
        setState((prevState) => ({
            ...prevState,
            loaderA1: true,
            tab1loader3: true
        }))

        if (tab1 && tab1.initFetch) {
            setState((prevState) => ({
                ...prevState,
                initFetch: true,
                loaderA1: false,
                loader1: false,
                tab1loader3: false
            }))
        }
        setState((prevState) => ({
            ...prevState,
            loader10: true, tab1loader2: true
        }))

        if (tab1 && tab1.initFetch) {
            setState((prevState) => ({
                ...prevState,
                totalAccounts: tab1.totalAccounts,
                initFetch: true,
                loaderA1: false,
                loader1: false,
                tab1loader2: false
            }))
        }
        else {
            instance({ url: `/api/dashboards/cms/14`, method: "GET" })
                .then((res) => {
                    setState((prevState) => ({
                        ...prevState,
                        totalAccounts: res, tab1loader2: false
                    }))
                    tab1Data = {
                        ...tab1Data,
                        totalAccounts: res,
                        initFetch: true,


                    }
                    dispatch(addTab1(tab1Data))

                })
                .catch((err) => {
                    // console.log("err 1====", err)
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader5: true
        }))


        if (tab6 && tab6.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader5: false,
                totalFleetSize: tab6.totalFleetSize || 0,
                clientVehiclesVehicleWise: tab6.clientVehiclesVehicleWise || [],
            }))
        }
        else {
            instance({ url: `/api/dashboards/cms/2`, method: "GET" })
                .then((res) => {

                    let makeData = [];
                    let colors = [
                        "#da5e5e",
                        "#f50057",
                        "#7b101b",
                        "#00c179",
                        "#d52f2f",
                        "#ec1c91",
                        "#28a788",
                        "#3f52b5e6",
                        "#594a86",
                        "#864a73",
                    ];
                    let maxUsedCount = Math.max(
                        ...res.data.map((item) => item.accessVehiclesCount)
                    );
                    let dtRes = res.data.reverse();
                    let usedPartPercentages = dtRes.map((item) => {
                        return {
                            ...item,
                            salesPercentage: (item.accessVehiclesCount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader5: false,
                        totalFleetSize: res.totalFleetCount,
                        clientVehiclesVehicleWise: usedPartPercentages,
                    }))

                    let dt = {
                        initFetch: true,
                        totalFleetSize: res.totalFleetCount,
                        clientVehiclesVehicleWise: usedPartPercentages
                    }
                    dispatch(addTab6(dt))
                })
                .catch((err) => { });

        }
        setState((prevState) => ({
            ...prevState,
            loader7: true, tab1loader1: true
        }))
        if (tab8 && tab8.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader7: false,
                tab1loader1: false,
                maintRequestClientWise: {
                    clientList: tab8.maintRequestClientWise.clientList,
                    totalInvoicesCount: tab8.maintRequestClientWise?.totalInvoicesCount || 0,
                },
                maintRequestClientWiseTab1: tab8.maintRequestClientWiseTab1 || 1,
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/3`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(
                        ...res.clientList.map((item) => item.count)
                    );
                    let usedPartPercentages =
                        res.clientList &&
                        res.clientList.map((item) => {
                            return {
                                ...item,
                                countPercentage: (item.count / maxUsedCount) * 100,
                            };
                        });
                    setState((prevState) => ({
                        ...prevState,
                        loader7: false,
                        tab1loader1: false,
                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                    }))


                    let dat = {
                        initFetch: true,
                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                    }
                    dispatch(addTab8(dat));

                })
                .catch((err) => {
                    console.log("err 3 ====", err);
                });
        }
        setState((prevState) => ({
            ...prevState,
            loader4: true,
            tab1loader5: true
        }))

        if (tab5 && tab5.initFetch) {
            let res = tab5.res || {}
            let maxUsedCount = Math.max(
                ...res.clientList.map((item) => item.saleNetAmount)
            );
            let usedPartPercentages = res.clientList.map((item) => {
                return {
                    ...item,
                    salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
                };
            });
            setState((prevState) => ({
                ...prevState,
                loader4: false,
                tab1loader5: false,
                salesClientsTab1: res?.totalSaleTotalAmount || 0,
                salesClients: {
                    ...res,
                    clientList: usedPartPercentages,
                },
                salesClients1: {
                    ...res,
                    clientList: usedPartPercentages,
                },
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/4`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(
                        ...res.clientList.map((item) => item.saleNetAmount)
                    );
                    let usedPartPercentages = res.clientList.map((item) => {
                        return {
                            ...item,
                            salesPercentage: (item.saleNetAmount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader4: false,
                        tab1loader5: false,

                        salesClientsTab1: res?.totalSaleTotalAmount || 0,
                        salesClients: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        salesClients1: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                    }))

                    let dat = {
                        res: res,
                        initFetch: true
                    }
                    dispatch(addTab5(dat));
                })
                .catch((err) => { })

        }

        setState((prevState) => ({
            ...prevState,
            loader6: true, tab1loader4: true
        }))

        if (tab7 && tab7.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader6: false,
                tab1loader4: false,
                salesClientsWise: {
                    ...tab7.salesClientsWise,
                    clientList: tab7.salesClientsWise.clientList,
                },
                totalOurDue: tab7?.totalOurDue || 0,
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/5`, method: "GET" })
                .then((res1) => {
                    let res = res1.clientList.reverse();
                    let maxUsedCount = Math.max(
                        ...res.map((item) => item.overDue)
                    );
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            ourDuePercentage:
                                (item.overDue / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader6: false,
                        tab1loader4: false,

                        salesClientsWise: {
                            ...res1,
                            clientList: usedPartPercentages,
                        },
                        totalOurDue: res1?.totalOurDue || 0,
                    }))
                    let dt = {
                        initFetch: true,
                        salesClientsWise: {
                            ...res1,
                            clientList: usedPartPercentages,
                        },
                        totalOurDue: res1?.totalOurDue || 0,
                    }
                    dispatch(addTab7(dt))
                })
                .catch((err) => {
                    console.log("err 5====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader2: true
        }))

        if (tab2 && tab2.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader2: false,
                maintenanceRequestCount: tab2?.maintenanceRequestCount || {},
                partsMaintRequest: tab2?.partsMaintRequest || {},
                serviceMaintRequest: tab2?.serviceMaintRequest || {},
                packageMaintRequest: tab2?.packageMaintRequest || {}
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/6`, method: "GET" })
                .then((res) => {
                    let dt = [];
                    for (const [key, value] of Object.entries(res)) {
                        dt.push({ name: key, value: value });
                    }
                    let maxUsedCount = Math.max(...dt.map((item) => item.value));
                    let usedPartPercentages = dt.map((item) => {
                        return {
                            ...item,
                            countPercentage: (item.value / maxUsedCount) * 100,
                        };
                    });
                    const findItem = usedPartPercentages.find(
                        (item) => item.name === "items"
                    );
                    const findService = usedPartPercentages.find(
                        (item) => item.name === "services"
                    );
                    const findPackages = usedPartPercentages.find(
                        (item) => item.name === "packages"
                    );
                    setState((prevState) => ({
                        ...prevState,
                        loader2: false,
                        maintenanceRequestCount: res,
                        partsMaintRequest: findItem,
                        serviceMaintRequest: findService,
                        packageMaintRequest: findPackages,
                    }))
                    // partsMaintRequest


                    let dat = {
                        maintenanceRequestCount: res,
                        partsMaintRequest: findItem,
                        serviceMaintRequest: findService,
                        packageMaintRequest: findPackages,
                        initFetch: true
                    }
                    dispatch(addTab2(dat));
                })
                .catch((err) => {
                    console.log("err 5====", err);
                });

        }
        setState((prevState) => ({
            ...prevState,
            loader10: true
        }))

        if (tab13 && tab13.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader10: false,
                vehiclesCategories: tab13?.data || [],

            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/7`, method: "GET" })
                .then((res) => {
                    let dt = [];
                    for (const [key, value] of Object.entries(res)) {
                        dt.push({ name: key, value: value });
                    }
                    let maxUsedCount = Math.max(...dt.map((item) => item.value));
                    let dtRes = dt.reverse();
                    let usedPartPercentages = dtRes.map((item) => {
                        return {
                            ...item,
                            countPercentage: (item.value / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader10: false,
                        vehiclesCategories: usedPartPercentages,

                    }))
                    // partsMaintRequest

                    let dat = {
                        initFetch: true,
                        data: usedPartPercentages
                    }
                    dispatch(addTab13(dat))
                })
                .catch((err) => {
                    console.log("err 7====", err);
                });

        }

        setState((prevState) => ({
            ...prevState,
            loader8: true
        }))

        if (tab9 && tab9.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader8: false,
                usedPart: tab9.data
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/8`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader8: false,
                        usedPart: usedPartPercentages
                    }))

                    let dt = {
                        data: usedPartPercentages,
                        initFetch: true
                    }
                    dispatch(addTab9(dt))
                })
                .catch((err) => {
                    console.log("err 8====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader13: true
        }))

        if (tab10 && tab10.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader13: false,
                usedService: tab10.data
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/9`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader13: false,
                        usedService: usedPartPercentages
                    }))

                    let dt = {
                        initFetch: true,
                        data: usedPartPercentages
                    }
                    dispatch(addTab10(dt))
                })
                .catch((err) => {
                    console.log("err 9====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader14: true
        }))

        if (tab11 && tab11.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader14: false,
                usedPackages: tab11.data
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/10`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                    let usedPartPercentages = res.map((item) => {
                        return {
                            ...item,
                            usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader14: false,
                        usedPackages: usedPartPercentages
                    }))

                    let dt = {
                        initFetch: true,
                        data: usedPartPercentages
                    }
                    dispatch(addTab11(dt))
                })
                .catch((err) => {
                    console.log("err 10====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader3: true
        }))

        if (tab3 && tab3.initFetch) {
            let res = tab3.collectionsAndOutStanding
            let balancePercentage =
                res.totalOutstandingBalance > res.totalPaid
                    ? (res.totalPaid / res.totalSaleNetAmount) * 100
                    : (res.totalPaid / res.totalSaleNetAmount) * 100;
            setState((prevState) => ({
                ...prevState,
                loader3: false,
                collectionsAndOutStanding: {
                    ...tab3.collectionsAndOutStanding,
                    balancePercentage: balancePercentage,
                },
            }))
        }
        else {
            // instance({url: `/api/dashboards/cms/12?to=${to}&from=${from}`, method: "GET" })
            instance({ url: `/api/dashboards/cms/12`, method: "GET" })
                .then((res) => {
                    let balancePercentage =
                        res.totalOutstandingBalance > res.totalPaid
                            ? (res.totalPaid / res.totalSaleNetAmount) * 100
                            : (res.totalPaid / res.totalSaleNetAmount) * 100;
                    setState((prevState) => ({
                        ...prevState,
                        loader3: false,
                        collectionsAndOutStanding: {
                            ...res,
                            balancePercentage: balancePercentage,
                        },
                    }))
                    let dt = {
                        initFetch: true,
                        collectionsAndOutStanding: {
                            ...res,
                            balancePercentage: balancePercentage,
                        }
                    }
                    dispatch(addTab3(dt))
                })
                .catch((err) => {
                    console.log("err 10====", err);
                });
        }


        // --------------------------------------------------------------------------  this.setState({ loader3: true }, () => {

        setState((prevState) => ({
            ...prevState,
            loader17: true
        }))
        if (tab17 && tab17.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader17: false,
                topVehiles: tab17.data,
            }))
        }
        else {
            instance({ url: `/api/dashboards/cms/17`, method: "GET" })
                .then((res) => {
                    setState((prevState) => ({
                        ...prevState,
                        loader17: false,
                        topVehiles: res || [],
                    }))

                    let dt = {
                        data: res || [],
                        initFetch: true
                    }
                    dispatch(addTab17(dt))
                })
                .catch((err) => {
                    console.log("err15====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader19: true
        }))

        if (tab19 && tab19.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader19: false,
                topMaintenancePerDay: tab19.data,
            }))
        }
        else {
            instance({ url: `/api/dashboards/cms/19`, method: "GET" })
                .then((res) => {
                    setState((prevState) => ({
                        ...prevState,
                        loader19: false,
                        topMaintenancePerDay: res.costPerDay || [],
                        topMaintenancePerKm: res.costPerKm || []
                    }))

                    let dt = {
                        data: res || [],
                        initFetch: true
                    }
                    dispatch(addTab19(dt))
                })
                .catch((err) => {
                    console.log("err19====", err);
                });
        }

        // --------------------------------------------------------------------------  this.setState({ loader3: true }, () => {

        setState((prevState) => ({
            ...prevState,
            loader9: true
        }))
        if (tab4 && tab4.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader9: false,
                salesDataYearly: tab4.salesDataYearly,
                allSaleData: tab4.allSaleData,
                salesDataMonthly: tab4.salesDataMonthly,
            }))
        }
        else {
            instance({ url: `/api/dashboards/cms/13`, method: "GET" })
                .then((res) => {
                    let monthlyDt = [];
                    let yealyDt = [];
                    let colors = ["#28A745", "#EAEAEA"];
                    let colors2 = ["#0288D1", "#EAEAEA"];
                    let ind = 0;
                    let ind2 = 0;
                    for (const [key, value, index] of Object.entries(res)) {
                        if (key === "monthlySale" || key === "monthlyTarget") {
                            let salePercentage = (res.monthlySale / res.monthlyTarget) * 100
                            let salePrecentRes = salePercentage > 100 ? 100 : salePercentage

                            monthlyDt.push({
                                name: key,
                                // y: value,
                                y: key === "monthlySale" ? salePrecentRes : 100 - salePrecentRes,

                                value: value,
                                formattedvalue: value,
                                color: colors[ind++],
                            });
                        } else {

                            let salePercentage = (res.yearlySale / res.yearlyTarget) * 100
                            let salePrecentRes = salePercentage > 100 ? 100 : salePercentage

                            yealyDt.push({
                                name: key,
                                y: key === "yearlySale" ? salePrecentRes : 100 - salePrecentRes,
                                value: value,
                                formattedvalue: value,
                                color: colors2[ind2++],
                            });
                        }
                    }
                    let makeDataMonthly = [{ data: monthlyDt }];
                    let makeDataYearly = [{ data: yealyDt }];

                    let yearlyList = res.yearlyList || {}
                    let monthlyList = res.monthlyList || {}
                    const formattedDataYearly = Object.keys(yearlyList).map((key) => ({
                        name: key,
                        y: yearlyList[key],
                    }));
                    const formattedDataMonthly = Object.keys(monthlyList).map((key) => ({
                        name: key,
                        y: monthlyList[key],
                    }));
                    // return formattedDataYearly;
                    setState((prevState) => ({
                        ...prevState,
                        loader9: false,
                        salesDataYearly: formattedDataYearly,
                        allSaleData: res,
                        salesDataMonthly: formattedDataMonthly,
                    }))

                    let dt = {
                        salesDataYearly: formattedDataYearly,
                        allSaleData: res,
                        salesDataMonthly: formattedDataMonthly,
                        initFetch: true
                    }
                    dispatch(addTab4(dt))
                })
                .catch((err) => {
                    console.log("err 10====", err);
                });
        }


        setState((prevState) => ({
            ...prevState,
            loader11: true
        }))
        if (tab14 && tab14.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader11: false,
                totalProfitTab14: tab14.data,
            }))

        }
        else {
            instance({ url: `/api/dashboards/cms/15`, method: "GET" })
                .then((res) => {
                    let maxUsedCount = Math.max(
                        ...res.clientList.map((item) => item.profit)
                    );
                    let calculateProfitPercentage = res.clientList.map((item) => {
                        return {
                            ...item,
                            countPercentage: (item.profit / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        loader11: false,
                        totalProfitTab14: calculateProfitPercentage,
                    }))

                    let dt = {
                        data: calculateProfitPercentage,
                        initFetch: true
                    }
                    dispatch(addTab14(dt))
                })
                .catch((err) => {
                    console.log("err15====", err);
                });
        }

        setState((prevState) => ({
            ...prevState,
            loader18: true
        }))

        if (tab18 && tab18.initFetch) {
            setState((prevState) => ({
                ...prevState,
                loader18: false,
                monthlySaleNetAmount: tab18.data,
            }))
        }
        else {
            instance({ url: `/api/dashboards/cms/18`, method: "GET" })
                .then((res) => {
                    setState((prevState) => ({
                        ...prevState,
                        loader18: false,
                        monthlySaleNetAmount: res || {},
                    }))

                    let dt = {
                        data: res || {},
                        initFetch: true
                    }
                    dispatch(addTab18(dt))
                })
                .catch((err) => {
                    console.log("err15====", err);
                });
        }
    };
    const getCMS2 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader5: true
        }))

        let url =
            to && from
                ? `/api/dashboards/cms/2?to=${to}&from=${from}`
                : `/api/dashboards/cms/2`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let makeData = [];
                let colors = [
                    "#da5e5e",
                    "#f50057",
                    "#7b101b",
                    "#00c179",
                    "#d52f2f",
                    "#ec1c91",
                    "#28a788",
                    "#3f52b5e6",
                    "#594a86",
                    "#864a73",
                ];

                res &&
                    res.data.map((item, index) => {
                        makeData.push({
                            name: item.contractNumber,
                            key: item.accessVehiclesCount,
                            y: item.accessVehiclesCount,
                            color: colors[index],
                        });
                    });
                let makeData2 = [{ data: makeData }];
                setState((prevState) => ({
                    ...prevState,
                    totalFleetSize: res.totalFleetCount, clientVehiclesVehicleWise: res.data, loader5: false
                }))

                let dt = {
                    initFetch: true,
                    clientVehiclesVehicleWise: res.data,
                    totalFleetSize: res.totalFleetCount
                }
                dispatch(addTab6(dt))
            })
            .catch((err) => { });

    };
    const getCMS3 = (to, from, chk) => {
        setState((prevState) => ({
            ...prevState,
            loader7: chk ? false : true, tab1loader1: chk ? true : false,
        }))
        let url =
            to && from
                ? `/api/dashboards/cms/3?to=${to}&from=${from}`
                : `/api/dashboards/cms/3`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                if (chk) {
                    setState((prevState) => ({
                        ...prevState,
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                        loader7: false,
                        tab1loader1: false
                    }))

                } else {
                    let maxUsedCount = Math.max(
                        ...res.clientList.map((item) => item.count)
                    );
                    let usedPartPercentages =
                        res.clientList &&
                        res.clientList.map((item) => {
                            return {
                                ...item,
                                countPercentage: (item.count / maxUsedCount) * 100,
                            };
                        });
                    setState((prevState) => ({
                        ...prevState,
                        loader7: false,
                        tab1loader1: false,

                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                    }))

                    let dat = {
                        initFetch: true,
                        maintRequestClientWise: {
                            clientList: usedPartPercentages,
                            totalInvoicesCount: res?.totalInvoicesCount || 0,
                        },
                        maintRequestClientWiseTab1: res?.totalDeliveryNotesCount || 1,
                    }
                    // this.props.dispatch(addTab8(dat));
                }
            })
            .catch((err) => {
                console.log("err 3 ====", err);
            });
    };
    const getCMS5 = (to, from, chk) => {
        setState((prevState) => ({
            ...prevState,
            loader6: chk ? false : true, tab1loader4: chk ? true : false,

        }))

        let url =
            to && from
                ? `/api/dashboards/cms/5?to=${to}&from=${from}`
                : `/api/dashboards/cms/5`;
        instance({ url: url, method: "GET" })
            .then((res1) => {
                if (chk) {
                    setState((prevState) => ({
                        ...prevState,
                        totalOurDue: res1?.totalOurDue,
                        loader6: false,
                        tab1loader4: false

                    }))

                } else {
                    let res = res1.clientList.reverse();

                    // let maxUsedCount = Math.max(...res.clientList?.map(item => item.outstandingBalance));
                    let maxUsedCount = Math.max(
                        ...res?.map((item) => item.overDue)
                    );
                    // let usedPartPercentages = res.clientList.map(item => {
                    //   return {  ...item, ourDuePercentage: (item.overDue / maxUsedCount) * 100
                    //   }
                    // })
                    let usedPartPercentages = res?.map((item) => {
                        return {
                            ...item,
                            ourDuePercentage:
                                (item.overDue / maxUsedCount) * 100,
                        };
                    });
                    setState((prevState) => ({
                        ...prevState,
                        salesClientsWise: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        loader6: false,
                        tab1loader4: false

                    }))

                    let dt = {
                        initFetch: true,
                        salesClientsWise: {
                            ...res,
                            clientList: usedPartPercentages,
                        },
                        totalOurDue: res?.totalOurDue || 0,
                    }
                    // this.props.dispatch(addTab7(dt))
                }
            })
            .catch((err) => {
                console.log("err 5====", err);
            });

    };
    const getCMS8 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader8: true
        }))
        let url =
            to && from
                ? `/api/dashboards/cms/8?to=${to}&from=${from}`
                : `/api/dashboards/cms/8`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                let usedPartPercentages = res.map((item) => {
                    return {
                        ...item,
                        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                    };
                });
                setState((prevState) => ({
                    ...prevState,
                    usedPart: usedPartPercentages, loader8: false
                }))
                let dt = {
                    data: usedPartPercentages,
                    initFetch: true
                }
                dispatch(addTab9(dt))
            })
            .catch((err) => {
                console.log("err 8====", err);
            });
    };
    const getCMS9 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader13: true
        }))

        let url =
            to && from
                ? `/api/dashboards/cms/9?to=${to}&from=${from}`
                : `/api/dashboards/cms/9`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                let maxUsedCount = Math.max(...res.map((item) => item.usedCount));
                let usedPartPercentages = res.map((item) => {
                    return {
                        ...item,
                        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                    };
                });
                setState((prevState) => ({
                    ...prevState,
                    usedService: usedPartPercentages, loader13: false
                }))

                let dt = {
                    initFetch: true,
                    data: usedPartPercentages
                }
                dispatch(addTab10(dt))
            })
            .catch((err) => {
                console.log("err 9====", err);
            });
    };
    const getCMS10 = (to, from) => {
        setState((prevState) => ({
            ...prevState,
            loader14: true
        }))

        let url =
            to && from
                ? `/api/dashboards/cms/10?to=${to}&from=${from}`
                : `/api/dashboards/cms/10`;
        instance({ url: url, method: "GET" })
            .then((res) => {
                // let res = res1.clientList;
                let maxUsedCount = Math.max(...res?.map((item) => item.usedCount));
                let usedPartPercentages = res.map((item) => {
                    return {
                        ...item,
                        usedCountPercentage: (item.usedCount / maxUsedCount) * 100,
                    };
                });
                setState((prevState) => ({
                    ...prevState,
                    usedPackages: usedPartPercentages, loader14: false
                }))

                let dt = {
                    initFetch: true,
                    data: usedPartPercentages
                }
                dispatch(addTab11(dt))
            })
            .catch((err) => {
                console.log("err 10====", err);
            });
    };
    const handleChange = async (name, e) => {
        if (name === "tab1") {
            setState(prevState => ({
                ...prevState,
                loader1: true
            }));
        }

        setState(prevState => ({
            ...prevState,
            [name]: e.label,
            loader1: name === "tab1" ? true : prevState.loader1
        }));

        const res = await getToFrom(e.value);

        if (name === "tab1") {
            await Promise.all([
                getCMS5(res.to, res.from, true),
                getCMS4(res.to, res.from, true),
                getCMS3(res.to, res.from, true),
            ]);
            setState(prevState => ({
                ...prevState,
                loader1: false
            }));
        } else if (name === "tab5") {
            getCMS4(res.to, res.from);
        } else if (name === "tab6") {
            getCMS2(res.to, res.from);
        } else if (name === "tab7") {
            getCMS5(res.to, res.from);
        } else if (name === "tab8") {
            getCMS3(res.to, res.from);
        } else if (name === "tab9") {
            getCMS8(res.to, res.from);
        } else if (name === "tab10") {
            getCMS9(res.to, res.from);
        } else if (name === "tab11") {
            getCMS10(res.to, res.from);
        } else {
            getCMS10(res.to, res.from);
        }
    };

    const openVehicle = (item) => {
        let dt = [];
        let ind = 0;
        let colors = [
            "#28A745",
            "#e86493",
            "#f6cc4e",
            "#EAEAEA",
            "#d52f2f",
            "#5d2c2c",
            "#45e6aa",
            "#427ace",
            "#477ac7",
            "#c747b5",
        ];
        for (const [key, value] of Object.entries(item.categoryCount)) {
            dt.push({
                name: key,
                y: value,
                value: value,
                formattedvalue: value,
                color: colors[ind++],
            });
        }
        let selectedData = [{ data: dt }];
        setState((prevState) => ({
            ...prevState,
            openGraph: true, selectedVehicle: selectedData
        }))

    };
    const CloseGraph = () => {
        setState((prevState) => ({
            ...prevState,
            openGraph: false, selectedVehicle: {}
        }))
    };
    useEffect(() => {
        let timezone = "Asia/Riyadh";

        if (
            logInUser &&
            logInUser.attributes &&
            logInUser.attributes.timezone
        ) {
            timezone = logInUser.attributes.timezone;
        }

        const now = moment().tz(timezone);

        // ======== dashboards/cms/16 - YTD (Year to Date) =========
        const startOfYear = now.clone().startOf("year");
        const endOfDay = now.clone().endOf("day");

        // ======== dashboards/cms/16 - MTD (Month to Date) =========
        const startOfMonth = now.clone().startOf("month");
        const endOfMonth = now.clone().endOf("month");

        // ======== Last year same period =========
        const lastYearStart = startOfYear.clone().subtract(1, "year");
        const lastYearEnd = endOfDay.clone().subtract(1, "year");

        getDashboardData(
            startOfYear.toISOString(),
            endOfDay.toISOString(),
            startOfMonth.toISOString(),
            endOfMonth.toISOString(),
            lastYearStart.toISOString(),
            lastYearEnd.toISOString()
        );
    }, []); // Only runs once on mount

    let clientVehiclesVehicleWiseChart = {
        config: pieChartDefault().initializeWithOptions({
            chart: {
                height: "310px",
            },
            // title: {
            //   text: "table.head"
            // },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: false,
                        format: "{point.name}: {point.y:.1f}",
                        style: {
                            fontWeight: "bold",
                            color: "currentColor",
                        },
                    },
                },
            },
            series: state.selectedVehicle,
            legend: {
                enabled: true,
            },
            yAxis: {
                gridLineWidth: 0,
            },
            tooltip: {
                formatter: function () {
                    return (
                        "<strong>" +
                        this.key +
                        "</strong>" +
                        " <br>" +
                        "<strong>" +
                        this.y.toFixed(2) +
                        "</strong>"
                    );
                },
            },
        }),
        show: true,
    };
    return (

        <div>
            <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                    display: "flex",
                    marginBottom: 10,
                    borderBottomWidth: 2,
                    borderBottomColor: "#707070",
                    borderBottomStyle: "dashed",
                }}
            >
                <Grid item xs={12} sm={6} md={3} lg={3} style={{ padding: "10px 20px 0px 20px" }}>
                    {state.loader4 ? (
                        <MaintenanceItemEmpty />
                    ) : (
                        <>
                            <Grid item xs={12} md={12}>
                                <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10",
                                        alignItems: "center",
                                    }}
                                >
                                    <p
                                        className="row-label"
                                        style={{
                                            textAlign: "left",
                                            fontWeight: 700,
                                            fontSize: 14,
                                            alignItems: "center",
                                        }}
                                    >
                                        {props.translate("clientSales")}
                                        <span style={{
                                            textAlign: "left",
                                            fontWeight: 500,
                                            fontSize: 12,
                                            alignItems: "center",
                                        }} >{" "}SAR</span>
                                    </p>
                                    <p
                                        className="row-label"
                                        style={{
                                            textAlign: "left",
                                            fontSize: 12,
                                            fontWeight: 500,
                                            width: 130,
                                        }}
                                    >
                                        <Select
                                            options={FiltersOptionWithoutMTD}
                                            value={{
                                                label: state.tab5 ? state.tab5 : "Select",
                                            }}
                                            onChange={(e) => handleChange("tab5", e)}
                                        />
                                    </p>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} style={{ marginTop: 10 }}>
                                <Scrollbar
                                    disableTracksWidthCompensation={true}
                                    style={{
                                        height:
                                            "320px",

                                    }}
                                    scrollerProps={{
                                        renderer: (props) => {
                                            const { elementRef, ...restProps } = props;
                                            return (
                                                <div {...restProps} ref={elementRef} id="scrollableDiv" />
                                            );
                                        },
                                    }}
                                >
                                    <ul className="md-bar-graphlist">
                                        {state.salesClients &&
                                            state.salesClients.clientList &&
                                            state.salesClients.clientList.map((d, index) => (
                                                <li>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            paddingRight: "5px",
                                                            height: 17,
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        <Tooltip
                                                            title={<Typography style={{ fontSize: "12px", }}>{d.contractName}</Typography>}
                                                            enterDelay={300}
                                                        >
                                                            <span
                                                                style={{
                                                                    maxWidth: "170px",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                            >{d.contractName}</span>
                                                        </Tooltip>
                                                        {" "}
                                                        {(() => {
                                                            try {
                                                                const saleNetAmount = d.saleNetAmount;
                                                                const integerAmount = Math.floor(saleNetAmount);
                                                                const formattedAmount = integerAmount.toLocaleString();
                                                                return formattedAmount;
                                                            } catch (error) {
                                                                console.error('Error:', error);
                                                                return "Error";
                                                            }
                                                        })()}
                                                    </div>
                                                    <LinearProgress
                                                        style={{ height: 11 }}
                                                        className="success"
                                                        variant="determinate"
                                                        value={parseInt(d.salesPercentage)}
                                                    />
                                                </li>
                                            ))}
                                    </ul>
                                </Scrollbar>

                            </Grid>
                        </>
                    )}
                </Grid>

                <Grid
                    item
                    xs={12} sm={6} md={3} lg={3}
                    style={{
                        padding: "10px 20px 0px 20px",
                        borderLeftWidth: "1px",
                        borderLeftColor: "#707070",
                        borderLeftStyle: "dashed",
                        borderTopWidth: state.xs ? 2 : 0,
                        borderTopColor: state.xs ? "#707070" : "none",
                        borderTopStyle: state.xs ? "dashed" : "none",
                    }}
                >
                    {state.loader5 ? (
                        <MaintenanceItemEmpty />
                    ) : (
                        <>
                            <Grid item xs={12} md={12}>
                                <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10",
                                        alignItems: "center",
                                    }}
                                >
                                    <p
                                        className="row-label"
                                        style={{
                                            marginTop: 10,
                                            textAlign: "left",
                                            fontWeight: 700,
                                            fontSize: 14,
                                        }}
                                    >
                                        <span>{props.translate("clientVehiclesCount")}</span>
                                    </p>
                                    <p>
                                        <Tooltip
                                            title={
                                                <Typography style={{ fontSize: "14px", }}>
                                                    {state?.totalFleetSize?.toLocaleString() || 0}
                                                </Typography>
                                            }
                                            placement="bottom-start"
                                            enterDelay={300}
                                            classes={{ tooltip: 'customTooltip' }}
                                        >
                                            <span
                                                className="row-label"
                                                style={{
                                                    fontSize: "22px",
                                                    fontWeight: "600",
                                                    fontStyle: "italic",
                                                    paddingLeft: 10,
                                                }}
                                            >
                                                {" "}
                                                {state && state.totalFleetSize ?
                                                    nFormatter(state.totalFleetSize, 2)
                                                    : 0}
                                            </span>
                                        </Tooltip>

                                    </p>
                                </Grid>
                            </Grid>

                            {!state.openGraph ? (
                                <Grid item xs={12} md={12} style={{ marginTop: 25 }}>
                                    <Scrollbar
                                        disableTracksWidthCompensation={true}
                                        style={{
                                            height:
                                                "320px",

                                        }}
                                        scrollerProps={{
                                            renderer: (props) => {
                                                const { elementRef, ...restProps } = props;
                                                return (
                                                    <div {...restProps} ref={elementRef} id="scrollableDiv" />
                                                );
                                            },
                                        }}
                                    >
                                        <ul className="md-bar-graphlist">
                                            {state.clientVehiclesVehicleWise &&
                                                state.clientVehiclesVehicleWise.map(
                                                    (d, index) => (
                                                        <li
                                                            onClick={() => openVehicle(d)}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    height: 17,
                                                                    overflow: "hidden",
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    title={<Typography style={{ fontSize: "12px", }}>{d.contractName}</Typography>}
                                                                    enterDelay={300}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            maxWidth: "170px",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap"
                                                                        }}
                                                                    >{d.contractName}</span>
                                                                </Tooltip>
                                                                <span>
                                                                    {(() => {
                                                                        try {
                                                                            const saleNetAmount = d.accessVehiclesCount;
                                                                            const integerAmount = Math.floor(saleNetAmount);
                                                                            const formattedAmount = integerAmount.toLocaleString();
                                                                            return formattedAmount;
                                                                        } catch (error) {
                                                                            console.error('Error:', error);
                                                                            return "Error";
                                                                        }
                                                                    })()}
                                                                </span>
                                                            </div>
                                                            <LinearProgress
                                                                style={{ height: 11 }}
                                                                className="light-green"
                                                                variant="determinate"
                                                                value={parseInt(d.salesPercentage)}
                                                            />
                                                        </li>
                                                    )
                                                )}
                                        </ul>
                                    </Scrollbar>
                                </Grid>
                            ) : (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            style={{ textAlign: "end", marginTop: 5 }}
                                        >
                                            <Button
                                                aria-label="back"
                                                size="small"
                                                color="inherit"
                                                onClick={() => CloseGraph()}
                                                id="backButton"
                                            >
                                                {props.translate("sharedBack")}
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={12} style={{ marginTop: 10 }}>
                                            <HighchartsReact highcharts={Highcharts} options={clientVehiclesVehicleWiseChart.config} />

                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </>
                    )}
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={3}
                    style={{
                        padding: "10px 20px 0px 20px",
                        borderTopWidth: state.xs ? 2 : 0,
                        borderTopColor: state.xs ? "#707070" : "none",
                        borderTopStyle: state.xs ? "dashed" : "none",
                        borderLeftWidth: "1px",
                        borderLeftColor: "#707070",
                        borderLeftStyle: "dashed",

                    }}>
                    {state.loader6 ? (
                        <MaintenanceItemEmpty />
                    ) : (
                        <>
                            <Grid item xs={12} md={12}>
                                <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10",
                                        alignItems: "center",
                                    }}
                                >
                                    <p
                                        className="row-label"
                                        style={{
                                            textAlign: "left",
                                            fontWeight: 700,
                                            fontSize: 14,
                                        }}
                                    >
                                        {props.translate("clientOutstanding")}
                                        <span style={{
                                            textAlign: "left",
                                            fontWeight: 500,
                                            fontSize: 12,
                                            alignItems: "center",
                                        }} >{" "}SAR</span>
                                    </p>

                                    <p
                                        className="row-label"
                                        style={{
                                            textAlign: "left",
                                            fontSize: 12,
                                            fontWeight: 500,
                                            width: 130,
                                        }}
                                    >
                                        <Select
                                            isDisabled={true}
                                            options={FiltersOption}
                                            value={{
                                                label: state.tab7 ? state.tab7 : "Select",
                                            }}
                                            onChange={(e) => handleChange("tab7", e)}
                                        />
                                    </p>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} style={{ marginTop: 10 }}>
                                <Scrollbar
                                    disableTracksWidthCompensation={true}
                                    style={{
                                        height:
                                            "320px",

                                    }}
                                    scrollerProps={{
                                        renderer: (props) => {
                                            const { elementRef, ...restProps } = props;
                                            return (
                                                <div {...restProps} ref={elementRef} id="scrollableDiv" />
                                            );
                                        },
                                    }}
                                >
                                    <ul className="md-bar-graphlist">
                                        {state.salesClientsWise &&
                                            state.salesClientsWise.clientList &&
                                            state.salesClientsWise.clientList.map(
                                                (d, index) => (
                                                    <li>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                height: 17,
                                                                overflow: "hidden",
                                                            }}
                                                        >
                                                            <Tooltip
                                                                title={<Typography style={{ fontSize: "12px", }}>{d.contractName}</Typography>}
                                                                enterDelay={300}
                                                            >
                                                                <span
                                                                    style={{
                                                                        maxWidth: "170px",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                >
                                                                    {d.contractName}</span>
                                                            </Tooltip>
                                                            <span>
                                                                {(() => {
                                                                    try {
                                                                        const saleNetAmount = d.overDue;
                                                                        const integerAmount = Math.floor(saleNetAmount);
                                                                        const formattedAmount = integerAmount.toLocaleString();
                                                                        return formattedAmount;
                                                                    } catch (error) {
                                                                        console.error('Error:', error);
                                                                        return "Error";
                                                                    }
                                                                })()}
                                                            </span>
                                                        </div>
                                                        <LinearProgress
                                                            style={{ height: 11 }}
                                                            className="purple"
                                                            variant="determinate"
                                                            value={parseInt(d.ourDuePercentage)}
                                                        />
                                                    </li>
                                                )
                                            )}
                                    </ul>
                                </Scrollbar>

                            </Grid>
                        </>
                    )}
                </Grid>

                <Grid
                    item
                    xs={12} sm={6} md={3} lg={3}
                    style={{
                        padding: "10px 20px 0px 20px",
                        borderLeftWidth: "1px",
                        borderLeftColor: "#707070",
                        borderLeftStyle: "dashed",
                        borderTopWidth: state.xs ? 2 : 0,
                        borderTopColor: state.xs ? "#707070" : "none",
                        borderTopStyle: state.xs ? "dashed" : "none",
                        borderTopWidth: state.sm ? 2 : 0,
                        borderTopColor: state.sm ? "#707070" : "none",
                        borderTopStyle: state.sm ? "dashed" : "none",
                    }}
                >

                    {state.loader7 ? (
                        <MaintenanceItemEmpty />
                    ) : (
                        <>
                            <Grid item xs={12} md={12}>
                                <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: "10",
                                        alignItems: "center",
                                    }}
                                >
                                    <p
                                        className="row-label"
                                        style={{
                                            textAlign: "left",
                                            fontWeight: 700,
                                            fontSize: 14,
                                        }}
                                    >
                                        {props.translate("clientMaint.InvoiceCount")}
                                    </p>
                                    <p
                                        className="row-label"
                                        style={{
                                            textAlign: "left",
                                            fontSize: 12,
                                            fontWeight: 500,
                                            width: 130,
                                        }}
                                    >
                                        <Select
                                            options={FiltersOption}
                                            value={{
                                                label: state.tab8 ? state.tab8 : "Select",
                                            }}
                                            onChange={(e) => handleChange("tab8", e)}
                                        />
                                    </p>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={12} style={{ marginTop: 10 }}>
                                <Scrollbar
                                    disableTracksWidthCompensation={true}
                                    style={{
                                        height:
                                            "320px",

                                    }}
                                    scrollerProps={{
                                        renderer: (props) => {
                                            const { elementRef, ...restProps } = props;
                                            return (
                                                <div {...restProps} ref={elementRef} id="scrollableDiv" />
                                            );
                                        },
                                    }}
                                >
                                    <ul className="md-bar-graphlist">
                                        {state.maintRequestClientWise &&
                                            state.maintRequestClientWise.clientList &&
                                            state.maintRequestClientWise.clientList.map(
                                                (d, index) => (
                                                    <li>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                height: 17,
                                                                overflow: "hidden",
                                                            }}
                                                        >
                                                            <Tooltip
                                                                title={<Typography style={{ fontSize: "12px", }}>{d.contractName}</Typography>}
                                                                enterDelay={300}
                                                            >
                                                                <span
                                                                    style={{
                                                                        maxWidth: "170px",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                >{d.contractName}</span>
                                                            </Tooltip>
                                                            {(() => {
                                                                try {
                                                                    const saleNetAmount = d.count;
                                                                    const integerAmount = Math.floor(saleNetAmount);
                                                                    const formattedAmount = integerAmount.toLocaleString();
                                                                    return formattedAmount;
                                                                } catch (error) {
                                                                    console.error('Error:', error);
                                                                    return "Error";
                                                                }
                                                            })()}
                                                        </div>
                                                        <LinearProgress
                                                            style={{ height: 11 }}
                                                            className="danger"
                                                            variant="determinate"
                                                            value={parseInt(d.countPercentage)}
                                                        />
                                                    </li>
                                                )
                                            )}
                                    </ul>
                                </Scrollbar>

                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
            <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                    display: "flex",
                    marginBottom: 10,
                    borderBottomWidth: 2,
                    borderBottomColor: "#707070",
                    borderBottomStyle: "dashed",
                }}
            >
                <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    style={{
                        padding: "0 10px 0 10px",
                        borderRightColor: state.xs ? "none" : "#707070",
                        borderRightStyle: state.xs ? "none" : "dashed",
                        borderRightWidth: state.xs ? "none" : 2,
                    }}
                >
                    {state.loader8 ? (
                        <MaintenanceItemEmpty />
                    ) : (
                        <>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10",
                                    alignItems: "center",
                                }}
                            >
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontWeight: 700,
                                        fontSize: 14,
                                    }}
                                >
                                    {props.translate("topParts")}
                                </p>
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontSize: 12,
                                        fontWeight: 500,
                                        width: 130,
                                    }}
                                >
                                    <Select
                                        options={FiltersOption}
                                        value={{
                                            label: state.tab9 ? state.tab9 : "Select",
                                        }}
                                        onChange={(e) => handleChange("tab9", e)}
                                    />
                                </p>
                            </Grid>
                            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
                                <Scrollbar
                                    disableTracksWidthCompensation={true}
                                    style={{
                                        height:
                                            "320px",

                                    }}
                                    scrollerProps={{
                                        renderer: (props) => {
                                            const { elementRef, ...restProps } = props;
                                            return (
                                                <div {...restProps} ref={elementRef} id="scrollableDiv" />
                                            );
                                        },
                                    }}
                                >
                                    <ul className="md-bar-graphlist">
                                        {state.usedPart &&
                                            state.usedPart.map((item) => {
                                                return (
                                                    <li>
                                                        <span style={{ display: "flex", justifyContent: "space-between" }} className="row-label">
                                                            <em>
                                                                {item?.itemName || ""}
                                                                {" - "}
                                                                {item?.itemCode || ""}
                                                            </em>{" "}
                                                            <strong>{item?.usedCount?.toLocaleString() || ""}</strong>

                                                        </span>
                                                        <LinearProgress
                                                            style={{ height: 5 }}
                                                            className="light-yellow"
                                                            variant="determinate"
                                                            value={item.usedCountPercentage}
                                                        />
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </Scrollbar>

                            </Grid>
                        </>
                    )}
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    style={{
                        padding: "0 10px 0 10px",
                        borderRightColor: state.xs ? "none" : "#707070",
                        borderRightStyle: state.xs ? "none" : "dashed",
                        borderRightWidth: state.xs ? "none" : 2,
                        borderTopWidth: state.xs ? 2 : 0,
                        borderTopColor: state.xs ? "#707070" : "none",
                        borderTopStyle: state.xs ? "dashed" : "none",
                    }}
                >
                    {state.loader13 ? (
                        <MaintenanceItemEmpty />
                    ) : (
                        <>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10",
                                    alignItems: "center",
                                }}
                            >
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontWeight: 700,
                                        fontSize: 14,
                                    }}
                                >
                                    {props.translate("topServices")}
                                </p>
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontSize: 12,
                                        fontWeight: 500,
                                        width: 130,
                                    }}
                                >
                                    <Select
                                        options={FiltersOption}
                                        value={{
                                            label: state.tab10 ? state.tab10 : "Select",
                                        }}
                                        onChange={(e) => handleChange("tab10", e)}
                                    />
                                </p>
                            </Grid>
                            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
                                <Scrollbar
                                    disableTracksWidthCompensation={true}
                                    style={{
                                        height:
                                            "320px",

                                    }}
                                    scrollerProps={{
                                        renderer: (props) => {
                                            const { elementRef, ...restProps } = props;
                                            return (
                                                <div {...restProps} ref={elementRef} id="scrollableDiv" />
                                            );
                                        },
                                    }}
                                >
                                    <ul className="md-bar-graphlist">
                                        {state.usedService &&
                                            state.usedService.map((item) => {
                                                return (
                                                    <li>
                                                        <span style={{ display: "flex", justifyContent: "space-between" }} className="row-label">
                                                            <em>
                                                                {item?.itemName || ""}
                                                                {" - "}
                                                                {item?.itemCode || ""}
                                                            </em>{" "}
                                                            <strong>{item?.usedCount?.toLocaleString() || ""}</strong>
                                                        </span>
                                                        <LinearProgress
                                                            style={{ height: 5 }}
                                                            className="light-red"
                                                            variant="determinate"
                                                            value={item.usedCountPercentage}
                                                        />
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </Scrollbar>

                            </Grid>
                        </>
                    )}
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    lg={4}
                    style={{
                        padding: "0 10px 0 10px",
                        borderTopWidth: state.xs ? 2 : 0,
                        borderTopColor: state.xs ? "#707070" : "none",
                        borderTopStyle: state.xs ? "dashed" : "none",
                    }}
                >
                    {state.loader14 ? (
                        <MaintenanceItemEmpty />
                    ) : (
                        <>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10",
                                    alignItems: "center",
                                }}
                            >
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontWeight: 700,
                                        fontSize: 14,
                                    }}
                                >
                                    {props.translate("topPackages")}
                                </p>
                                <p
                                    style={{
                                        textAlign: "left",
                                        fontSize: 12,
                                        fontWeight: 500,
                                        width: 130,
                                    }}
                                >
                                    <Select
                                        options={FiltersOption}
                                        value={{
                                            label: state.tab11 ? state.tab11 : "Select",
                                        }}
                                        onChange={(e) => handleChange("tab11", e)}
                                    />
                                </p>
                            </Grid>
                            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
                                <Scrollbar
                                    disableTracksWidthCompensation={true}
                                    style={{
                                        height:
                                            "320px",

                                    }}
                                    scrollerProps={{
                                        renderer: (props) => {
                                            const { elementRef, ...restProps } = props;
                                            return (
                                                <div {...restProps} ref={elementRef} id="scrollableDiv" />
                                            );
                                        },
                                    }}
                                >
                                    <ul className="md-bar-graphlist">

                                        {state.usedPackages &&
                                            state.usedPackages.map((item) => {
                                                return (
                                                    <li>
                                                        {/* <span className="row-label"> */}
                                                        <span style={{ display: "flex", justifyContent: "space-between" }} className="row-label">
                                                            <em>
                                                                {item?.itemName || item?.name || ""}
                                                                {" - "}
                                                                {item?.itemCode || ""}
                                                            </em>{" "}
                                                            <strong>{item?.usedCount?.toLocaleString() || ""}</strong>
                                                        </span>
                                                        <LinearProgress
                                                            style={{ height: 5 }}
                                                            className="light-green"
                                                            variant="determinate"
                                                            value={item.usedCountPercentage}
                                                        />
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </Scrollbar>

                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </div>
    )
}

export default MoreWidgets